
import axios from "axios";
import check from "~/store/elementChecker"
export default {
  name: "account",
  async asyncData({ app,req,context, route, store }) {
    let host = '';
    if (process.server) {
      host = req.headers.host + route.fullPath
    }else{
      host = location.host + route.fullPath
    }
    let preview = "";
    if (app.$cookies.get("preview")) {
      let pr = (app.$cookies.get("preview") || "").split(":::");
      if (pr[1] == store.getters.store.id) {
        preview = `&preview=${pr[0]}`;
      }
    }
    // check(store.getters.store.id,route,app,preview,((store.getters.store||{}).build_no||{}).timestamp,(store.getters.store.build||{}).build_no);
      try{
        let res = await axios.get(`${process.env.axiosUrl}/stores/${store.getters.store.id}?elements=account&build=${(store.getters.store.build||{}).build_no}&elementsonly=true${preview}`,{
        headers:{
          shopster:host
        }
      });
        if ((res.data||{}).id) {
          store.commit('elements',[...store.getters.store.eshop.elements.filter(e=>e.static),...res.data.eshop.elements]);
          let es = JSON.parse(JSON.stringify(store.getters.store));
          es.eshop.elements = (await app.$hyperElement.populateData({page:'account',app})) || []
          store.commit("store", es);
        }
      }catch(e){
        console.error(e);
      }
  },
  head() {
    return {
      title: "Ο Λογαριασμός μου",
    };
  },
  data() {
    return {
      showPassword:false,
      tab: "userInfo",
      isLogged: false,
      login: {
        email: "",
        password: "",
      },
      register: {
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        password_confirm: "",
        phone: "",
      },
      user: {
        first_name: "",
        last_name: "",
        invoice: {},
      },
      newAddress: {
        address: "",
        town: "",
        postal_code: "",
        level: "",
      },
      invoice: {
        vatid: "",
        doy: "",
        company: "",
        activity: "",
      },
      password: "",
      password_confirm: "",
      orders: [],
      forgotPassword: false,
      forgotPasswordEmail: "",
    };
  },
  async mounted() {
    if (this.$route.params.tab) {
      this.tab = this.$route.params.tab;
    }

    this.$hyperUtility.paintSvg(
      "login",
      "#login",
      "#320A64",
      this.$store.getters.store.eshop.secondary
    );
    this.$hyperUtility.paintSvg(
      "signup",
      "#signup",
      "#320A64",
      this.$store.getters.store.eshop.secondary
    );
  },
  methods: {
       
    toggleInspect(o) {
      o.inspect = !o.inspect;
    },
    deleteAddress(index) {
      this.user.addresses = this.user.addresses.filter(
        (a, ind) => ind != index
      );
      this.$hyperUser.saveUser(this.user);
    },
    addAddress() {
      this.user.addresses.push(JSON.parse(JSON.stringify(this.newAddress)));
      this.newAddress = {
        address: "",
        town: "",
        postal_code: "",
        level: "",
      };
      this.$hyperUser.saveUser(this.user);
    },
  },
};
